module.exports = __webpack_public_path__ + "static/media/fiscal_lime_may25.c7da8bee.csv";